interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  className?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
  className = '',
}: SectionHeadingProps) {
  const alignClass =
    align === 'center'
      ? 'text-center mx-auto items-center'
      : 'text-left items-start';
  return (
    <div className={`flex flex-col ${alignClass} max-w-3xl ${className}`}>
      {eyebrow && (
        <div className="gsap-reveal mb-4 inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.25em] text-white/50">
          <span className="w-6 h-px bg-white/30" />
          {eyebrow}
        </div>
      )}
      <h2 className="gsap-reveal group/title font-display text-3xl md:text-5xl lg:text-6xl font-normal leading-[1.05] cursor-default">
        <span className="title-shimmer inline-block">{title}</span>
      </h2>
      {description && (
        <p className="gsap-reveal mt-5 text-base md:text-lg text-white/60 leading-relaxed max-w-2xl">
          {description}
        </p>
      )}
    </div>
  );
}